import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

import { doLogin, fetchMe } from "../../actions/authActions";

import logo from "../../../assets/logo.png";
import { routes } from "../../constants/routes";

const containerStyles = {
  //height: '600px'
  height: "100vh"
};

const cardStyles = {
  //height: '600px'
  minWidth: "40vw"
};

/**
 * Komponent zawierający formularz logowania
 */
class Login extends React.Component {

  state = {
    user: {
      email: "",
      password: ""
    }
  }

  /**
   * Zatwierdzenie formularza
   */
  handleSubmit = async (e) => {
    e.preventDefault();

    await this.props.doLogin(this.state.user);
    this.props.fetchMe();

  };

  /**
   * Obsluga zmiany elementów formularza i aktualizacja stanu
   */
  handleInputChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let user = { ...this.state.user, [name]: value };
    this.setState({ user });
  };

  render() {
    return (
      <div className="w3-display-container" style={containerStyles}>
        <div className="w3-card-4 w3-display-middle" style={cardStyles}>
          <div className="w3-container">
            <h1 className="w3-center">
              <img src={logo} alt="Flow24 Admin" />
              {/*<FormattedMessage
                id="app.loginPage.title"
                defaultMessage="Login"
              />*/}
            </h1>
          </div>

          <form
            className="w3-container w3-padding"
            onSubmit={this.handleSubmit}
          >
            <div className="w3-row-padding">
              <input
                className="w3-input"
                type="text"
                name="email"
                onChange={this.handleInputChange}
                value={this.state.user.email}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="user.email" defaultMessage="E-mail" />
              </label>
            </div>

            <div className="w3-row-padding">
              <input
                className="w3-input"
                type="password"
                name="password"
                onChange={this.handleInputChange}
                value={this.state.user.password}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="user.password"
                  defaultMessage="Password"
                />
              </label>
            </div>

            <div className="w3-bar">
              <button
                className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                type="submit"
              >
                <FormattedMessage
                  id="app.loginPage.action.submit"
                  defaultMessage="E-mail"
                />
              </button>
            </div>
          </form>
          <footer className="w3-container w3-theme-dark">
            <div className="w3-bar">
              <Link to={routes.FORGOT_PASSWORD} className="w3-bar-item w3-right w3-small w3-btn">Nie pamiętasz hasła?</Link>
            </div>
          </footer>
        </div>

      </div>
    );
  }
}

Login.propTypes = {
  //akcja serwerowa - logowanie uzytkowanika
  doLogin: PropTypes.func.isRequired,
  //akcja serwerowa - pobieranie uzytkownika
  fetchMe: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authenticated: state.authReducer.authenticated
});

const mapDispatchToProps = ({
  doLogin: doLogin,
  fetchMe: fetchMe
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
